import React, {useEffect, useState} from 'react';
import _ from "lodash";
import FormFlowWrapper from "../../theme/wrappers/FormFlowWrapper";
import {addErrorAlert, toggleGlobalLoader} from "../../../store/calls/alertLoadingDispatch";
import api from "../../../store/api";



function CSSGrantQualificationPage(props) {

    let [qualification, setQualification] = useState(null);
    let [data, setData] = useState({})
    let [error, setError] = useState('')

    const pullData = (query_params) => {
        const lead_id = props.match.params.projectLeadId;
        toggleGlobalLoader(true)

        return api.get(`/project-estimate/${lead_id}`)
            .then((res) => {
                // handle case that project is in pace district but we don't have funders
                const data = _.cloneDeep(res.data);
                // this.props.setFocusedLoanEstimate(data);
                setData(data);

                if ((data?.estimates || []).length) {
                    setQualification(true)
                } else {
                    setQualification(false)
                }

            })
            .catch((err) => {
                let msg;
                if (!err.response) {
                    msg ="There seems to have been a connectivity issue, we couldn't complete the build process with our server."
                } else {
                    msg = "Something seems to have gone wrong on our end, we weren't able to process this application. Please try again in a moment."
                }

                addErrorAlert(msg)

            })
            .then(() => {
                toggleGlobalLoader(false);
            });
    }

    useEffect(() => {
         return pullData({})
    }, [])



    const isQualified = () => {
        return (
            <>
                <h2 className="is-size-2 has-text-primary ">
                    Your project qualifies for grants.
                </h2>
                <div className="mt-5">
                    <div className="button is-primary">Apply</div>
                </div>
            </>
        )

    }

    const isNotQualified = () => {
        return (
            <>
                <h2 className="is-size-2 has-text-primary">
                    Your project is not in the right area to qualify.
                </h2>
                <div className="mt-5">
                    <div className="button is-primary"
                         onClick={() => {
                             window.location = "https://renewablegateway.cleanfi.com" + window.location.pathname
                         }}
                    >Search CleanFi for Financing for this project</div>
                </div>
            </>
        )
    }


    return (
         <FormFlowWrapper>
             {
                 qualification === null ?
                     <p>Loading</p> :
                 (qualification ? isQualified() : isNotQualified())
             }

         </FormFlowWrapper>
     )
}


export default CSSGrantQualificationPage